import React from 'react';

export const ShutterLeftFold = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 106.9 77.1"
      width="85"
      {...props}
    >
      <path fill="#fff" d="M5.6.8h95.8v67.8H5.6z" />
      <path
        d="M101.3 69.3H5.6c-.4 0-.8-.3-.8-.8V.8c0-.5.3-.8.8-.8h95.8c.4 0 .8.3.8.8v67.8c-.1.4-.4.7-.9.7zM6.4 67.8h94.2V1.6H6.4v66.2z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M5.6.8h95.8v67.8H5.6z" />
      <path
        d="M101.3 69.3H5.6c-.4 0-.8-.3-.8-.8V.8c0-.5.3-.8.8-.8h95.8c.4 0 .8.3.8.8v67.8c-.1.4-.4.7-.9.7zM6.4 67.8h94.2V1.6H6.4v66.2z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M10 5.3h86.8v58.8H10z" />
        <path d="M96.9 64.9H10c-.4 0-.8-.3-.8-.8V5.3c0-.4.3-.8.8-.8h86.8c.4 0 .8.3.8.8v58.8c.1.4-.3.8-.7.8zm-86.1-1.6h85.3V6H10.8v57.3z" />
      </g>
      <path
        d="M106.2 69.3H.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h105.4c.4 0 .7.3.7.7.1.4-.2.7-.6.7z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M5.9 1l36.2 8.4.2 66.7L5.9 67z" />
        <path
          d="M42.9 77.1L5.3 67.7V0l37.5 8.7.1 68.4zM6.6 66.3L41.7 75l-.2-65-35-8.1.1 64.4z"
          fill="#fff"
        />
        <path fill="#233762" d="M9.7 8.8l28.8 6.8v4.7L9.7 13.6z" />
        <path
          d="M38.8 20.9l-29.4-7V8.3l29.4 6.9v5.7zm-28.7-7.7l28.1 6.6v-3.9L10.1 9.3v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M9.7 13.6l28.8 6.7v4.8L9.7 18.3z" />
        <path
          d="M38.8 25.6l-29.4-7V13l29.4 7v5.6zM10.1 18l28.1 6.6v-3.9l-28.1-6.6V18z"
          fill="#fff"
        />
        <path fill="#233762" d="M9.7 18.3l28.8 6.8v4.8L9.7 23.1z" />
        <path
          d="M38.9 30.4l-29.4-7v-5.6l29.4 7v5.6zm-28.8-7.7l28.1 6.7v-3.9l-28.1-6.7v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M9.7 23.1l28.8 6.8v4.8L9.7 27.9z" />
        <path
          d="M38.9 35.3l-29.4-7v-5.6l29.4 7v5.6zm-28.8-7.8l28.1 6.7v-3.9l-28.1-6.7v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M9.7 27.9l28.8 6.8v4.8L9.7 32.6z" />
        <path
          d="M38.9 40L9.4 33v-5.6l29.4 7 .1 5.6zm-28.8-7.7L38.2 39v-3.9l-28.1-6.7v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M9.7 32.6l28.8 6.9v4.8L9.7 37.4z" />
        <path
          d="M38.9 44.8L9.4 37.7v-5.6l29.5 7.1v5.6zM10.1 37l28.1 6.8v-3.9l-28.1-6.8V37z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M9.7 37.4l28.8 6.9.1 4.8-28.8-7z" />
          <path
            d="M38.9 49.6L9.4 42.5v-5.6L38.9 44v5.6zm-28.8-7.8l28.1 6.8v-3.9l-28.1-6.8v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M9.8 42.1l28.8 7v4.8l-28.8-7z" />
          <path
            d="M38.9 54.4L9.4 47.2v-5.6l29.5 7.2v5.6zm-28.8-7.9l28.1 6.9v-3.9l-28.1-6.8v3.8z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M9.8 46.9l28.8 7v4.8L9.8 51.6z" />
          <path
            d="M38.9 59.2L9.4 52v-5.6l29.5 7.2v5.6zm-28.8-7.9l28.2 6.9v-3.9l-28.1-6.9-.1 3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M9.8 51.7l28.8 7.1v4.8L9.8 56.5z" />
          <path
            d="M38.9 64.1L9.4 56.8v-5.6l29.5 7.2v5.7zm-28.8-8L38.2 63v-3.9L10 52.2l.1 3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M9.8 56.5l28.8 7.1v4.8L9.8 61.2z" />
          <path
            d="M38.9 68.9L9.4 61.6V56l29.5 7.3v5.6zm-28.8-8l28.2 7V64l-28.2-7v3.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M23.2 12l1.9.4.1 52.7-1.9-.5z" />
      </g>
      <g>
        <path fill="#233762" d="M43.6 9l37.1-8v66l-37.1 9.1z" />
        <path
          d="M81.3 67.7l-38.4 9.4V8.3L81.3 0v67.7zm-37 7.4L80 66.3V1.9L44.3 9.7v65.4z"
          fill="#fff"
        />
        <path fill="#233762" d="M47.6 15.2L77 8.8v4.7L47.6 20z" />
        <path
          d="M77.4 13.9l-30.1 6.7v-5.7l30.1-6.6v5.6zM48 19.5l28.7-6.4V9.3L48 15.6v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M47.6 20L77 13.5v4.8l-29.4 6.6z" />
        <path
          d="M77.4 18.6l-30.1 6.7v-5.7L77.4 13v5.6zM48 24.3l28.7-6.4V14L48 20.4v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M47.6 24.9L77 18.3V23l-29.4 6.7z" />
        <path
          d="M77.4 23.4l-30.1 6.8v-5.7l30.1-6.7v5.6zM48 29.2l28.7-6.5v-3.9L48 25.2v4z"
          fill="#fff"
        />
        <path fill="#233762" d="M47.6 29.7L77 23.1v4.7l-29.4 6.7z" />
        <path
          d="M77.4 28.2l-30.1 6.9v-5.7l30.1-6.8v5.6zM48 34l28.7-6.5v-3.9L48 30.1V34z"
          fill="#fff"
        />
        <path fill="#233762" d="M47.6 34.5L77 27.8v4.8l-29.4 6.8z" />
        <path
          d="M77.4 32.9l-30.1 6.9v-5.7l30.1-6.9v5.7zM48 38.8l28.7-6.6v-3.9L48 34.9v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M47.6 39.4L77 32.6v4.8l-29.4 6.8z" />
        <path
          d="M77.4 37.7l-30.1 7V39l30.1-6.9v5.6zm-29.4 6L76.7 37v-3.9L48 39.7v4z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M47.6 44.2L77 37.4v4.7L47.6 49z" />
          <path
            d="M77.4 42.5l-30.1 7v-5.7l30.1-7v5.7zm-29.4 6l28.7-6.7v-3.9L48 44.5v4z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M47.6 49L77 42.1v4.8l-29.4 6.9z" />
          <path
            d="M77.4 47.2l-30.1 7.1v-5.7l30.1-7v5.6zM48 53.3l28.7-6.8v-3.9L48 49.3v4z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M47.6 53.8L77 46.9v4.7l-29.4 7z" />
          <path
            d="M77.4 52l-30.1 7.2v-5.7l30.1-7.1V52zM48 58.1l28.7-6.8v-3.9L48 54.2v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M47.6 58.7l29.4-7v4.7l-29.4 7.1z" />
          <path
            d="M77.4 56.8L47.3 64v-5.7l30.1-7.2v5.7zM48 63l28.7-6.9v-3.9L48 59v4z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M47.6 63.5L77 56.4v4.8l-29.4 7.1z" />
          <path
            d="M77.4 61.5l-30.1 7.3v-5.7l30.1-7.2v5.6zM48 67.8l28.7-6.9V57L48 63.8v4z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M61.6 12.2l1.9-.5v52.8l-1.9.4z" />
      </g>
    </svg>
  );
};
